/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';
export const getCertificate = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.GROUP_CERTIFICATE, data).then((res: IOutput) => {
        return res.data;
    });
};
